module.exports = __webpack_public_path__ + "img/3.09c8aec9.jpg";